<app-generic-field [disabled]="disabled"
                   [filters]="filters"
                   [disabledColumns]="disabledColumns"
                   [disabledButtons]="disabledButtons"
                   [disableRouterLink]="disableRouterLink"
                   [linkLabel]="(hideCode ? '' : detail && detail.code + ' / ') + (detail && detail.name)"
                   [selectLabel]="'une entité'"
                   [pk]="detail && detail.code"
                   [path]="'entities'"
                   (openModalEvent)="openModal()"
                   (resetEvent)="reset()"
                   [(ngModel)]="detail"
                   name="entity-field">
</app-generic-field>
